import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-account-recovery-page',
  templateUrl: './account-recovery-page.component.html',
  styleUrls: ['./account-recovery-page.component.scss']
})
export class AccountRecoveryPageComponent implements OnInit {

  isMinorThanTablet: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 768px)');

  constructor(
    public breakpointObserver: BreakpointObserver,
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  handleGoBack() {
    this.router.navigate(['/'], { state: { confirmDeactivate: true } });
  }

}
